export const getUsageClass = (pPct, lgPct, threshold, includeLowUsage) => {
    let usageClass;
    if (pPct >= (lgPct + threshold)) {
        usageClass = 'high-usage';
    } else if (includeLowUsage && pPct <= (lgPct - threshold)) {
        usageClass = 'low-usage';
    }
    return usageClass;
};

export const pitchFreq = (stat, countKey, totAllKey, kZonKey, totKey, numFbInRepertoire, lgavgkzon) => {
    const pitNumTot = stat && stat[totKey || `t${countKey}`];
    if (pitNumTot > 0) {
        const pitNumKZon = stat[kZonKey || `p${countKey}`];
        const pitUsage = pitNumKZon / pitNumTot;

        if (!stat.isfastball) {
            const pitUsageAll = stat.pitches / stat[totAllKey];
            if (pitUsage > (pitUsageAll + 0.10)) {
                return 'high-usage';
            }
        } else if (stat.isfastball && countKey === '30' && pitUsage >= 0.945) {
            return 'high-usage';
        } else if (stat.isfastball) {
            const fxtype = numFbInRepertoire === 1 ? 1 : stat.fxtype;
            if (fxtype === 1) {
                const lgAvgCt = lgavgkzon.find((avg) => avg.fxtype === fxtype);
                const lgAvgAll = lgavgkzon.find((avg) => avg.fxtype === null);
                if (lgAvgCt && lgAvgAll && lgAvgAll[`t${countKey}`] > 0) {
                    return getUsageClass(pitUsage, lgAvgCt[`t${countKey}`] / lgAvgAll[`t${countKey}`], 0.10);
                }
            }
        }
    }
    return '';
};

export const kzoneAccuracy = (pitNumKZon, pitNumTot, countKey, pitchtype, lgavgkzon) => {
    const lgAvg = lgavgkzon.find((avg) => avg.fxtype === pitchtype || (avg.fxtype === null && !pitchtype));
    if (pitNumTot > 0 && lgAvg && lgAvg[`t${countKey}`] > 0) {
        const pEst = lgAvg[`kzon${countKey}`] / lgAvg[`t${countKey}`];
        const stdDev = Math.sqrt(pEst * (1 - pEst) / 200);
        return getUsageClass(pitNumKZon / pitNumTot, pEst, 2 * stdDev, true);
    }
    return '';
};
